const E164_REGEX = /^\+\d{8,15}$/

/**
 * Build a wa.me direct chat link for an E.164 phone number.
 * Returns null if the number is not valid E.164.
 */
export const waMeLink = (
  e164?: string | null,
  text?: string | null,
): string | null => {
  if (!e164 || typeof e164 !== 'string') {
    return null
  }
  const trimmed = e164.trim()
  if (!E164_REGEX.test(trimmed)) {
    return null
  }
  const digits = trimmed.slice(1) // remove '+'
  const base = `https://wa.me/${digits}`
  if (text !== undefined && text !== null && text !== '') {
    return `${base}?text=${encodeURIComponent(text)}`
  }
  return base
}

/**
 * Build an invite link to the workspace sending number with pre-filled "Hi".
 * Returns null if the number is not valid E.164.
 */
export const waMeInviteLink = (sendingE164?: string | null): string | null => {
  return waMeLink(sendingE164, 'Hi')
}

/**
 * Build a WhatsApp share link without a recipient number.
 */
export const waMeShareLink = (text: string): string => {
  return `https://wa.me/?text=${encodeURIComponent(text ?? '')}`
}
